import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[boiBlurOnClose]'
})
export class BlurOnCloseDirective {
  @HostListener('close', ['$event']) blurOnClose(event: any): void {
    (document.activeElement as HTMLElement).blur();
  }
}
